import type { HTMLAttributes } from "react";

import { DragHandle } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { StyledScoringRuleDragHandle } from "./styles";

type Props = Omit<HTMLAttributes<HTMLDivElement>, "color">;

export const ScoringRuleDragHandle = ({ ...dragHandleProps }: Props) => (
    <StyledScoringRuleDragHandle
        {...dragHandleProps}
        data-automation="scoring-rule-card.drag-handle"
    >
        <DragHandle
            size="xs"
            color={colorsPalettes.carbon[200]}
        />
    </StyledScoringRuleDragHandle>
);
